// <zzy-logo size="32" sub="true|false" wordmark="true|false"></zzy-logo>
// Lockup oficial · ZZYON Brand Manual v1.0
class ZzyLogo extends HTMLElement {
  static get observedAttributes() { return ['size', 'sub', 'wordmark']; }
  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }
  render() {
    const size = parseInt(this.getAttribute('size') || '32', 10);
    const showSub = this.getAttribute('sub') !== 'false';
    const showWord = this.getAttribute('wordmark') !== 'false';

    // Proporções do lockup oficial (manual da marca)
    const wordSize = Math.round(size * 0.62);
    const subSize  = Math.max(8, Math.round(size * 0.24));

    this.innerHTML = `
      <span style="display:inline-flex;align-items:center;gap:${Math.max(8, size * 0.32)}px;font-family:var(--zzy-font);color:currentColor;font-feature-settings:var(--zzy-font-features)">
        <svg viewBox="0 0 200 200" width="${size}" height="${size}" aria-label="ZZYON" style="flex-shrink:0;color:currentColor">
          <circle cx="100" cy="100" r="88" fill="none" stroke="currentColor" stroke-width="9"/>
          <path d="M 54 54 L 144 54 L 60 100 L 144 100 L 60 146 L 144 146"
                fill="none" stroke="currentColor" stroke-width="12" stroke-linecap="square"/>
          <circle cx="178" cy="52" r="8" fill="#3B6EFF"/>
        </svg>
        ${showWord ? `
          <span style="display:inline-flex;flex-direction:column;line-height:1">
            <span style="font-size:${wordSize}px;font-weight:800;color:currentColor;letter-spacing:0.02em">ZZYON</span>
            ${showSub ? `<span style="font-size:${subSize}px;letter-spacing:0.42em;color:rgba(255,255,255,0.7);font-weight:600;margin-top:3px">DO BRASIL</span>` : ''}
          </span>
        ` : ''}
      </span>
    `;
  }
}
customElements.define('zzy-logo', ZzyLogo);
